import React from "react";

/**
 * react-table의 getToggleRowSelectedProps()는 `indeterminate` 값을 함께 내려주는데,
 * 이 값을 그대로 <input>에 전달하면 React가 비표준 DOM 속성 경고를 띄운다.
 * indeterminate는 DOM 프로퍼티이므로 ref로 직접 설정해 경고를 방지한다.
 */
export const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef(null);
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      if (resolvedRef.current) {
        resolvedRef.current.indeterminate = Boolean(indeterminate);
      }
    }, [resolvedRef, indeterminate]);

    return <input type="checkbox" ref={resolvedRef} {...rest} />;
  },
);

IndeterminateCheckbox.displayName = "IndeterminateCheckbox";

export default IndeterminateCheckbox;
